import { StyleSheet, View } from 'react-native'
import Text from 'theme/Text'
import { ExtendingFooterStyles } from 'styles/scenes/home/book/_components/ExtendingFooter'
import React, { useEffect, useRef } from 'react'
import { colorList } from 'utils/colors'
import Icon from 'components/atoms/Icon'
import isEqual from 'react-fast-compare'


const IconWithCounter = ( props ) => {
	
	const refCount = useRef( 0 );
	const refAnimation = useRef( null );
	const { icon, count } = props;
	
	useEffect( () => {
		if( refCount.current === count ) return;
		refCount.current = count;
	}, [ count ] );
	
	const animationReset = () => {
		refAnimation.current = null
	};
	
	let content = [
		<Icon
			key={ 'timeslotCounter-icon' }
			icon={ icon }
			size={ 30 }
			style={ staticStyles.iconColorLight }>
			
			
		</Icon>
	];
	
	if( count > 0 ){
		content.push(
			<View
				key={ 'timeslotCounter-view' }
				style={ ExtendingFooterStyles.timeslotCounter }>
				
				<Text style={ staticStyles.textFontSize9 }>{count}</Text>
			</View>
		);
	}
	
	return (
		<View>
			{ content }
		</View>
	);
}
//IconWithCounter.whyDidYouRender = true;

const staticStyles = StyleSheet.create({
	iconColorLight: {
		color: colorList.BLACK.light,
	},
	textFontSize9: {
		fontSize: 9,
	},
});

export default React.memo( IconWithCounter, isEqual );
